import React from 'react'
import PropTypes from 'prop-types'
import CSS from './impact-figures.module.css'

export const ImpactFigures = ({ children, theme }) => {
    return (
        <section className={`block bg-${theme}`}>
            <div className={`${CSS.impactFigures} container`}>
                {children}
            </div>
        </section>
    )
}

ImpactFigures.propTypes = {
    theme: PropTypes.string
}
ImpactFigures.defaultProps = {
    theme: 'default'
}

export const ImpactFigure = ({value, label}) => {
    return (
        <div className={CSS.impactFigure}>
            <p className={CSS.impactFigureValue}>{value}</p>
            <p className={CSS.impactFigureLabel}>{label}</p>
        </div>
    )
}

ImpactFigure.propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
}
ImpactFigure.defaultProps = {
    value: '14,235',
    label: 'Impact figure caption'
}